/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareCutIcon16Light = forwardRef('CheckSquareCutIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 4a2 2 0 0 1 2-2h5.5a.5.5 0 0 0 0-1H4a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V8.5a.5.5 0 0 0-1 0V11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Z" }),
        React.createElement("path", { d: "M14.117 3.497a.5.5 0 1 0-.707-.708L7.905 8.294a.75.75 0 0 1-1.06 0L4.854 6.303a.5.5 0 1 0-.708.707L6.138 9a1.75 1.75 0 0 0 2.474 0l5.505-5.503Z" })));
});
